import { useRef, useState } from 'react';
import { ImagePlus, Loader2 } from 'lucide-react';
import { api, formatApiError, resolveMediaSrc } from '@/lib/api';

const inputCls = 'w-full bg-ink border border-white/15 px-3 py-2.5 text-sm text-cream placeholder:text-white/30 focus:border-champagne focus:outline-none transition-colors';

export const ImageUploadField = ({ value, onChange, label, testid }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setError('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post('/upload', fd);
      onChange(data.url);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  return (
    <div className="sm:col-span-2">
      <label className="block text-[10px] uppercase tracking-[0.25em] text-white/40 mb-1.5">{label}</label>
      <div className="flex gap-2">
        <input
          data-testid={`${testid}-url`}
          className={inputCls}
          placeholder="Paste image URL, or upload →"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
        />
        <button
          type="button"
          data-testid={`${testid}-upload-btn`}
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="shrink-0 inline-flex items-center gap-2 border border-champagne/60 text-champagne px-4 text-[11px] uppercase tracking-[0.15em] hover:bg-champagne hover:text-ink transition-colors disabled:opacity-60"
        >
          {uploading ? <Loader2 size={14} className="animate-spin" /> : <ImagePlus size={14} />}
          {uploading ? 'Uploading' : 'Upload'}
        </button>
        <input
          ref={fileRef}
          data-testid={`${testid}-file-input`}
          type="file"
          accept="image/jpeg,image/png,image/webp,image/gif"
          className="hidden"
          onChange={handleFile}
        />
      </div>
      {value && (
        <img src={resolveMediaSrc(value)} alt="Preview" className="mt-3 h-28 object-cover border border-white/10" onError={(e) => { e.target.style.display = 'none'; }} />
      )}
      {error && <p className="mt-2 text-sm text-red-400">{error}</p>}
    </div>
  );
};
